import React from 'react';
import { Typography } from '@mui/material';
import { fontSize as fs, fontWeight as fw } from '../../utils/accounting/styles';
import { formatCurrency } from '../../utils/accounting/formatters';

const CurrencyText = ({ amount, negative, color, bold, size = 'xs', withPrefix = true, sx = {} }) => {
  const num = typeof amount === 'string' ? parseFloat(amount) : (amount || 0);
  const isNeg = negative || num < 0;
  const displayAmount = Math.abs(num);
  const text = formatCurrency(displayAmount, { withPrefix });

  return (
    <Typography
      component="span"
      sx={{
        fontSize: fs[size],
        fontWeight: bold ? fw.bold : fw.normal,
        color: color ? `${color}.main` : (isNeg ? 'error.main' : 'text.primary'),
        ...sx,
      }}
    >
      {isNeg ? `(${text})` : text}
    </Typography>
  );
};

export default CurrencyText;
